import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { PersonService } from '../services/person.service';
import { Firestore, collection, query, where, getDocs, Timestamp } from '@angular/fire/firestore';
import { Result } from '../models/result.interface';
import { Entry } from '../models/entryFS.interface';

declare const $: JQueryStatic;

@Component({
  selector: 'app-trainer-profile',
  templateUrl: './trainer-profile.component.html',
  styleUrls: ['./trainer-profile.component.scss']
})
export class TrainerProfileComponent implements OnInit {
  public showInfo: any;
  public showId: any;
  public personId: any;
  public personInfo: any;
  public entries: any[] = [];
  public suffix: string;
  public entryNumber: string;
  public displayEntries: any[] = [];
  constructor(
    private _route: ActivatedRoute,
    private personService: PersonService,
    private firestore: Firestore
  ) {
    this.entryNumber = (this._route.snapshot.params?.entry??'').replace('us_','') ?? '';
    this.personId = (this._route.snapshot.params?.personID??'').replace('us_','') ?? '';
    this.showId = (this._route.snapshot.params?.showID??'') ?? '';
    this.suffix = '';
  }

  ngOnInit(): void {
    this.getPersonData(this.personId, this.showId.replace('us_',''));
    this.suffix = this.showId.includes('us_') ? 'us_' : '';
  }

  public getPersonData(personId, showId){
    if(!personId || !showId){
      $.NotificationApp.send('Error', 'Invalid person or show ID', 'bottom-right', '#bf441d', 'error');
      return;
    }
    this.personService.getPerson(personId, showId).subscribe(response => {
      this.personInfo = response.data.personInfo;
      this.getEntriesByTrainer();
    });
  }

  async getEntriesByTrainer() {
    try {
      console.log(this.personId, this.showId)
      const masterListsRef = collection(this.firestore, 'masterLists');
      const masterListsSnapshot = await getDocs(query(
        masterListsRef,
        where('id_entrenador', '==', parseInt(this.personId)),
        where('show', '==', this.showId)
      ));

      // Paso 2: Enriquecer cada entry con resultados del endpoint externo
      const entries = await Promise.all(
        masterListsSnapshot.docs.map(async d => {
          const entryData = d.data();
          const results = await this.getEntryResults(entryData.id_caballo);
          return { ...entryData, results };
        })
      );
      this.flattenEntriesForDisplay(entries)
      // Aquí puedes llamar a flattenEntriesForDisplay() después
    } catch (error) {
      console.error('Error getting entries by trainer', error);
    }
  }

  async getEntryResults(horseId: number | string): Promise<any[]> {
    const myHeaders = new Headers();
    myHeaders.append("x-api-key", "7cc263a1-a490-4337-8302-151490495e56");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Content-Type", "application/json");

    let url = "https://api.ecuestre.digital/profiles/horse/";
    if (this.showId.includes('us_')) {
      url = 'https://api.equestrian.digital/profiles/horse/';
    }

    const raw = JSON.stringify({ "horseId": horseId });
    const response = await fetch(url, {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    });

    if (!response.ok) return [];
    const data = await response.json();
    return data.resultsData || [];
  }

  public formatDate(date: string): string {
    return new Date(date).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' });
  }

  flattenEntriesForDisplay(entries) {
    this.entries = [];
    for (const entry of entries) {
      if (entry.results && Array.isArray(entry.results)) {
        for (const result of entry.results) {
          this.entries.push({
            entry: entry.entry, // o entry.numero según tu estructura
            horse: entry.horseName,
            horseID: entry.id_caballo,
            competitionID: result.competitionId,
            rider: entry.riderName,
            classNumber: result.number,
            className: result.className,
            count: result.count || '-', // si tienes este campo
            rank: result.rank || '-',
            ring: result.ring || result.Ring || '-', // ajusta según tu JSON
            day: result.date || '-', // o formatea la fecha si lo deseas
            estStart: result.estStart || '-', // si tienes hora estimada
            // ...otros campos que quieras mostrar
          });
        }
      }
    }
    console.log(this.entries)
  }

}

export interface NotificationApp {
  /**
   * Send Notification
   *
   * @param heading heading text
   * @param body body text
   * @param position position e.g top-right, top-left, bottom-left, etc
   * @param loaderBgColor loader background color
   * @param icon icon which needs to be displayed
   * @param hideAfter automatically hide after seconds
   * @param stack stack
   * @param showHideTransition show hide transition
   */
  send: (
    heading: string,
    body: string,
    position:' bottom-left' | 'bottom-right' | 'bottom-center' | 'top-right' | 'top-left' | 'top-center' | 'mid-center',
    loaderBgColor: string,
    icon: 'error' | 'success' | 'warning' | 'info',
    hideAfter?: number,
    stack?: number,
    showHideTransition?: boolean
  ) => void;
}

export interface JQueryStatic{
  NotificationApp: NotificationApp;
}
